module.exports = __webpack_public_path__ + "static/media/PDF.69567517.png";